import styled from 'styled-components';
import { COLOR, FONT, TYPOGRAPHY } from './../../theme/constants';
import config from './../../config';
import { Button, FlexContainer } from '@emarketer/componentlibrary';

//const config = getConfig().publicRuntimeConfig;

export const NavPickerWrapper = styled.div`
  position: relative;
  width: 100%;
  top: 0 !important;
  left: 0;
  background: ${COLOR.WHITE};
  margin: 0 auto;
  z-index: 900;
  padding: 0px;
  display: none;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 40px;

  @media (max-width: 1200px) {
    border-radius: 0px;
  }

  &.active {
    display: block;

    .fr-scrim-out {
      display: block;
      width: 100%;
      height: 100vh;
      top: 0;
      background: ${COLOR.DARKGREY};
      opacity: 0.8;
    }
  }

  @media (min-width: 1150px) {
    max-width: 1160px;
    min-height: 625px;
    overflow: hidden;
    left: 0;
    right: 0;
    margin: auto;
    border: 1px solid ${COLOR.GRAYMEDIUM};
    top: 30px;
    -webkit-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }

  @media (min-width: 1340px) {
    max-width: 1300px;
  }

  @media (min-height: 768px) {
    min-height: 700px;
  }
`;
export const NavPickerMetaContainer = styled.div`
  z-index: 5;
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
  position: relative;
  overflow: auto;

  @media (min-width: 1024px) {
    background: ${COLOR.WHITE};
    border-bottom: 1px solid ${COLOR.GRAYMEDIUM};
    padding: 20px 20px;
  }
`;
export const NavPickerMetaLeft = styled.div`
  float: left;
  width: 70%;

  @media (min-width: 1150px) {
    width: 30%;
  }
`;
export const NavPickerMetaTriggerContainer = styled.div`
  width: 100%;
  min-width: 200px;
  background: ${COLOR.WHITE};
  border: 1px solid ${COLOR.GRAYMEDIUM};
  height: 46px;
  position: relative;
  cursor: pointer;
  border-radius: 40px;

  &:hover {
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  }
`;
export const NavPickerMetaTriggerLeft = styled.div`
  display: inline-block;
  height: 46px;
  font-size: 16px;
  color: ${COLOR.BLACK};
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 50px;
  width: 100%;
  white-space: nowrap;
`;
export const NavPickerMetaTriggerText = styled.span`
  display: inline-block;
  padding: 12px 20px;
  ${TYPOGRAPHY.BOLD};
`;
export const NavPickerMetaTriggerRight = styled(FlexContainer)`
  position: absolute;
  right: 1px;
  top: 0;
  width: 50px;
  height: 43px;
  border-left: 1px solid ${COLOR.GRAYMEDIUM};
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
`;
export const NavPickerMetaCenter = styled.div`
  display: none;

  @media (min-width: 1150px) {
    display: block !important;
    font-family: ${FONT.FAMILYLABG};
    font-size: 18px;
    font-weight: 900;
    float: left;
    padding-left: 2%;

    span {
      color: red;
    }
  }
`;
export const BecomeAClientSubmit = styled.div`
  @media (min-width: 1024px) {
    display: inline-block;
    padding: 14px 0 14px 14px;

    a {
      background-color: #007eff;
      border-radius: 25px;
      color: white;
      font-size: 14px;
      font-weight: 600;
      font-style: normal;
      padding: 14px 36px;
      text-align: center;
      text-decoration: none;

      &:hover {
        background-color: #3395fd;
      }
    }
  }
`;
export const NavPickerMetaRight = styled(Button)<{ onClick: any; className: string }>`
  margin-top: 8px;
  box-sizing: border-box;
  display: none;
  right: 3%;
  float: right;
  width: 33px;
  height: 46px;
  position: relative;

  &.active {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  span {
    ${TYPOGRAPHY.BOLD};
    font-size: 10px;
    color: #c9c9c9;
    display: block;
  }

  @media (min-width: 1024px) {
    cursor: pointer;
  }
`;
